<script>
import {isArray} from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import service from '../../../../domain/grv/services'
import {GRV_DETRO} from '../../../../domain/grv/helpers/tipos-grv'
import ArquivosGrv from './grv/ArquivosGrv'
import TituloSecao from './grv/TituloSecao'
import BtnCheckPossui from './CheckPossui'
import GrvMixins from '../mixins/GrvMixins'

const POSSUI = '1'
const NAO_POSSUI = '2'
const NAO_MARCA = '5'

export default {
  name: 'ggv',
  mixins: [GrvMixins],
  components: {ArquivosGrv, TituloSecao, BtnCheckPossui},
  data () {
    return {
      dataRequiredLoaded: false,
      dataRequired: {equipamentos: []},
      // Dados da GRV: só leitura aqui, nunca editados nesta tela.
      grv: {
        id: null,
        numero: null,
        placa: null,
        placaOriginal: null,
        chassi: null,
        marca: null,
        modelo: null,
        cor: null,
        renavam: null,
        ano: null,
        numeroMotor: null,
        bemCategoria: null
      },
      extraModel: {dataApreensao: null, horaApreensao: null},
      // Dado isolado da vistoria (GGV) — nunca compartilhado com os equipamentos/fotos da GRV.
      arquivosGgv: [],
      conforme: false,
      equipamentosGgvOrigem: [],
      ggvJaExiste: false,
      cadastroError: null,
      atualizadoSucesso: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.$loaderOverlay.open().message('Carregando GGV')
      service.find(this.$route.params.id, true)
        .then((response) => {
          const data = response.data
          this.grv.id = data.id
          this.grv.numero = data.numero
          this.grv.placa = data.placa
          this.grv.placaOriginal = data.placaOriginal
          this.grv.chassi = data.chassi
          this.grv.marca = data.marca
          this.grv.modelo = data.modelo
          this.grv.cor = data.cor
          this.grv.renavam = data.renavam
          this.grv.ano = data.ano
          this.grv.numeroMotor = data.numeroMotor
          this.grv.bemCategoria = data.bemCategoria ? data.bemCategoria.id : null

          const dataApreensao = JSON.parse(JSON.stringify(data.dataApreensao))
          this.extraModel.dataApreensao = dataApreensao ? moment(dataApreensao.date).format('L') : null
          this.extraModel.horaApreensao = dataApreensao ? moment(dataApreensao.date).format('LT') : null

          this.ggvJaExiste = !!(data.ggv && data.ggv.id)
          this.conforme = this.ggvJaExiste ? !!data.ggv.conforme : false
          this.arquivosGgv = this.ggvJaExiste && isArray(data.ggv.arquivos) ? data.ggv.arquivos : []
          this.equipamentosGgvOrigem = this.ggvJaExiste && isArray(data.ggv.equipamentos) ? data.ggv.equipamentos : []

          return service.dataRequired(GRV_DETRO)
        })
        .then((response) => {
          this.dataRequired = response.data
          this.dataRequired.equipamentos = []
          this.dataRequiredLoaded = true
          this.$loaderOverlay.hide()
          if (this.grv.bemCategoria) this.carregarEquipamentos()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    carregarEquipamentos () {
      service.listarEquipamentosPorCategoria(this.grv.bemCategoria, false).then((response) => {
        this.dataRequired.equipamentos = response.data
        this.dataRequired.equipamentos.forEach((e) => {
          Vue.util.defineReactive(e, 'checked', false)
          Vue.util.defineReactive(e, 'possui', NAO_MARCA)
          const achado = this.equipamentosGgvOrigem.find((item) => item.equipamento.id === e.id)
          if (achado) {
            e.checked = true
            // Booleano puro, não string — o toggle (checkbox nativo) trata qualquer string não-vazia
            // como truthy, então NAO_POSSUI ('2') apareceria visualmente como "Possui" se fosse string.
            e.possui = !!achado.possui
          }
        })
      })
    },
    marcaEquipamento (e, v) {
      v.checked = e.target.checked
    },
    printError (err) {
      if (isArray(err)) return err[0]
      return err
    },
    submit () {
      const confirmar = window.confirm('Tem certeza que deseja confirmar a vistoria (GGV)?')
      if (!confirmar) return
      this.cadastroError = null
      this.$loaderOverlay.open().message('Processando')
      const payload = {
        isGgv: true,
        ggv: {conforme: this.conforme},
        equipamentos: this.dataRequired.equipamentos.map((e) => ({
          id: e.id,
          // e.possui começa como o sentinel NAO_MARCA (string '5', truthy) até o usuário realmente
          // tocar no toggle — precisa resolver pra POSSUI/NAO_POSSUI aqui, senão o valor cru ('5')
          // vaza pro backend e o item marcado seria ignorado.
          possui: e.checked ? (e.possui ? POSSUI : NAO_POSSUI) : NAO_MARCA
        })),
        // Ao contrário da tela de GRV, a Vistoria não tem um upload separado por FormData pra fotos
        // "pelo celular" (nem a da Polícia tem) — o conteúdo base64 já vem preenchido de qualquer
        // forma, então precisa ir tudo no mesmo payload, sem filtrar por fromCelular (senão a foto
        // some silenciosamente: nunca é enviada em lugar nenhum).
        arquivosGgv: this.arquivosGgv,
        // updateAction acessa $arrayRequest['lacres'] direto (sem null-coalescing) mesmo fora do
        // fluxo de lacres — payload parcial precisa incluir a chave, mesmo vazia, senão dá erro 500.
        lacres: []
      }
      service.atualizacao(payload, this.grv.id, GRV_DETRO)
        .then(() => {
          this.$loaderOverlay.hide()
          this.atualizadoSucesso = true
          this.loadData()
          this.$nextTick(() => {
            if (this.$el.querySelector('#sucessMsg')) this.$el.querySelector('#sucessMsg').focus()
          })
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          this.cadastroError = response && response.data && response.data.errors
          this.$nextTick(() => {
            if (this.$refs.error) this.$refs.error.focus()
          })
        })
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="dataRequiredLoaded">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <titulo-secao class="bg-warning text-black">
              <strong>Vistoria (GGV)</strong><br>
              Confira os equipamentos/acessórios e as fotos no momento da guarda deste veículo
            </titulo-secao>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao salvar a vistoria, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Vistoria (GGV) salva com sucesso!</div>
                      </div>

                      <div class="panel panel-default wrapper-sm m-b">
                        <div class="row">
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">GRV</label>
                            <div>{{ grv.numero }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Data de Apreensão</label>
                            <div>{{ extraModel.dataApreensao }} {{ extraModel.horaApreensao }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Placa Original</label>
                            <div>{{ grv.placaOriginal || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Placa Ostentada</label>
                            <div>{{ grv.placa || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Chassi</label>
                            <div>{{ grv.chassi || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Marca</label>
                            <div>{{ grv.marca || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Modelo</label>
                            <div>{{ grv.modelo || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Cor</label>
                            <div>{{ grv.cor || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Renavam</label>
                            <div>{{ grv.renavam || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Ano</label>
                            <div>{{ grv.ano || '-' }}</div>
                          </div>
                          <div class="col-sm-3 col-xs-6 m-b-sm">
                            <label class="control-label">Número do Motor</label>
                            <div>{{ grv.numeroMotor || '-' }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Equipamentos / Acessórios da Vistoria</titulo-secao>
                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group b-b padder-v" v-for="equip in dataRequired.equipamentos" :key="equip.id">
                        <div class="col-sm-offset-2 col-sm-10">
                          <div class="row">
                            <div class="col-xs-4">
                              <label class="i-checks m-b-none">
                                <input v-model="equip.checked" @change="marcaEquipamento($event, equip)" type="checkbox"
                                       :id="'ggv-equip-' + equip.id"
                                       tabindex="0"
                                       aria-checked="false"
                                       aria-invalid="false"><i></i>
                              </label>
                              <label :for="'ggv-equip-' + equip.id">{{equip.nome}}</label>
                            </div>
                            <div class="col-xs-8">
                              <btn-check-possui v-model="equip.possui" v-show="equip.checked"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <titulo-secao>Fotos da Vistoria</titulo-secao>
                  <arquivos-grv :arquivos="arquivosGgv" :tipos-arquivo="dataRequired.tipoArquivo" origem="ggv"></arquivos-grv>

                  <titulo-secao>Parecer Final</titulo-secao>
                  <div class="wrapper-md m-b-lg">
                    <div class="row">
                      <label class="col-sm-4 control-label">Em conformidade com a GRV</label>
                      <div class="col-sm-8">
                        <select v-model="conforme" class="form-control">
                          <option :value="true">Conforme</option>
                          <option :value="false">Não conforme</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-block btn-lg">{{ggvJaExiste ? 'Atualizar Vistoria (GGV)' : 'Confirmar GGV'}}</button>
                        <div class="text-center">
                          * a confirmação inclui imediatamente este bem no pátio e transmite as informações para o DETRO
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Ggv.vue?2bf2b954